import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { useTranslations } from "next-intl";
import { IconButton, MuscleButton } from "@modules/shared/components/buttons";
import { useMediaQuery } from "react-responsive";
import { useCarsSearchContext } from "@lib/context/cars/cars-search-context";
import APP_CONFIGURATION from "@lib/app.config";
import { useSideOverPanel } from "@modules/mobile/hooks/useSideOverPanel";
import { useForwardNode } from "@modules/mobile/hooks/useForwardNode";
import { XMarkIcon } from "@heroicons/react/24/outline";
import CarsLocationsAutocomplete from "@modules/cars/components/search/car-search-form/components/location-autocomplete-input";
import TimePickerInput from "@modules/cars/components/search/car-search-form/components/time-picker-input";
import MuscleCalendarDateInput from "@modules/shared/components/calendar-date-input";
import { SearchCarsFormQuerySchema } from "@modules/cars/schemas/search-cars-query";
import { getShortDateString } from "@lib/util/date-ops";
import { encodeObjectToQueryString } from "@lib/util/object-ops";
import useMuscleRouter from "@lib/hooks/use-muscle-router";
import { useRouter } from "next/navigation";
import useCssModules from "@lib/hooks/use-css-modules";
import InformativeCard from "@modules/shared/components/cards/informative";
const DEFAULT_LOCATION_VALUE = {
  id: "disabled",
  latitude: 0,
  longitude: 0,
  value: "",
  iata: "",
  type: ""
};
export const EditCarSelection = () => {
  var _APP_CONFIGURATION$co, _APP_CONFIGURATION$co2;
  const t = useTranslations("Cars.SearchForm");
  const {
    search,
    setSearch
  } = useCarsSearchContext();
  const {
    togglePanel
  } = useSideOverPanel();
  const {
    setNode
  } = useForwardNode();
  const muscleRouter = useMuscleRouter();
  const nativeRouter = useRouter();
  const isMobile = useMediaQuery({
    maxWidth: (_APP_CONFIGURATION$co = APP_CONFIGURATION === null || APP_CONFIGURATION === void 0 || (_APP_CONFIGURATION$co2 = APP_CONFIGURATION.config.screensConfig) === null || _APP_CONFIGURATION$co2 === void 0 ? void 0 : _APP_CONFIGURATION$co2.md) !== null && _APP_CONFIGURATION$co !== void 0 ? _APP_CONFIGURATION$co : 767
  });
  const {
    cssModules
  } = useCssModules();
  const {
    editCarSelectionPanelContainer,
    editCarSelectionHeaderContainer,
    editCarSelectionTitle,
    editCarSelectionApplyButtonContainer,
    editCarSelectionInputsContainer
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.views.mobile.EditCarSelection) || {};
  const SAME_AS_PICKUP_OPTION = {
    iata: "same_as_pickup",
    id: "same_as_pickup",
    value: t("SAME_AS_PICKUP")
  };
  const handlePickupLocationChange = autocompleteOption => {
    if (!search || !autocompleteOption) return;
    setSearch(_objectSpread(_objectSpread({}, search), {}, {
      pickUpLocation: autocompleteOption.value
    }));
  };
  const handleDropoffLocationChange = autocompleteOption => {
    if (!search || !autocompleteOption) return;
    setSearch(_objectSpread(_objectSpread({}, search), {}, {
      dropOffLocation: autocompleteOption.value
    }));
  };
  const handleDateChange = _ref => {
    let {
      from,
      to
    } = _ref;
    if (!search || !from || !to) return;
    setSearch(_objectSpread(_objectSpread({}, search), {}, {
      pickUpDate: from,
      dropOffDate: to
    }));
  };
  const handlePickupTimeChange = time => {
    if (!search) return;
    setSearch(_objectSpread(_objectSpread({}, search), {}, {
      pickUpTime: time
    }));
  };
  const handleDropoffTimeChange = time => {
    if (!search) return;
    setSearch(_objectSpread(_objectSpread({}, search), {}, {
      dropOffTime: time
    }));
  };
  const handleSearch = () => {
    const validatedSearch = SearchCarsFormQuerySchema.parse(search);
    const searchParams = encodeObjectToQueryString(validatedSearch);
    nativeRouter.push("/cars/search?search=".concat(searchParams));
    setTimeout(() => {
      togglePanel();
    }, 100);
  };
  return __jsx("div", {
    className: editCarSelectionPanelContainer
  }, __jsx("div", {
    className: editCarSelectionHeaderContainer
  }, __jsx(IconButton, {
    icon: __jsx(XMarkIcon, {
      className: "h-6 w-6",
      "aria-hidden": "true"
    }),
    onClickButton: () => togglePanel()
  }), __jsx("h2", {
    className: editCarSelectionTitle
  }, t("EDIT_SEARCH"))), __jsx("div", {
    className: editCarSelectionInputsContainer
  }, __jsx("div", null, __jsx(CarsLocationsAutocomplete, {
    onClick: () => {
      setNode("CarPickupLocationSelection");
    },
    dataTestId: "cars-search-pickup-location-input-edit",
    className: "w-full",
    name: "pickUpLocation",
    label: t("PICKUP_LOCATION_LABEL"),
    value: (search === null || search === void 0 ? void 0 : search.pickUpLocation) || DEFAULT_LOCATION_VALUE,
    onSelectOption: handlePickupLocationChange,
    disablePopper: isMobile,
    disableLabelAnimation: true,
    disableXButton: true
  })), __jsx("div", null, __jsx(CarsLocationsAutocomplete, {
    onClick: () => {
      setNode("CarDropoffLocationSelection");
    },
    dataTestId: "cars-search-dropoff-location-input-edit",
    className: "w-full",
    name: "dropOffLocation",
    label: t("DROP_OFF_LOCATION_LABEL"),
    value: (search === null || search === void 0 ? void 0 : search.dropOffLocation) || SAME_AS_PICKUP_OPTION,
    onSelectOption: handleDropoffLocationChange,
    disablePopper: isMobile,
    disableLabelAnimation: true,
    disableXButton: true
  })), __jsx("div", null, __jsx(MuscleCalendarDateInput, {
    onClick: () => {
      setNode("CarDatesSelection");
    },
    dataTestId: "cars-search-calendar-input-edit",
    customInputClass: APP_CONFIGURATION.config.forms.search_input_class,
    label: t("DATES_LABEL"),
    value: [search !== null && search !== void 0 && search.pickUpDate ? new Date(search.pickUpDate) : undefined, search !== null && search !== void 0 && search.dropOffDate ? new Date(search.dropOffDate) : undefined],
    onChangeValue: handleDateChange,
    applyImmediate: true,
    dateRangeMode: true,
    formatDateSelected: date => {
      return getShortDateString(date, false);
    },
    hideLabel: true
  })), __jsx("div", {
    className: "flex flex-row gap-4"
  }, __jsx("div", {
    className: "flex-1"
  }, __jsx(TimePickerInput, {
    onClick: () => {
      setNode("CarPickupTimeSelection");
    },
    dataTestId: "cars-search-pickup-time-input-edit",
    customInputClass: APP_CONFIGURATION.config.forms.search_input_class,
    label: t("PICKUP_TIME_LABEL"),
    value: search !== null && search !== void 0 && search.pickUpTime ? new Date(search.pickUpTime) : new Date(),
    onChangeValue: handlePickupTimeChange,
    disablePopper: isMobile,
    disableLabelAnimation: true
  })), __jsx("div", {
    className: "flex-1"
  }, __jsx(TimePickerInput, {
    onClick: () => {
      setNode("CarDropoffTimeSelection");
    },
    dataTestId: "cars-search-dropoff-time-input-edit",
    customInputClass: APP_CONFIGURATION.config.forms.search_input_class,
    label: t("DROP_OFF_TIME_LABEL"),
    value: search !== null && search !== void 0 && search.dropOffTime ? new Date(search.dropOffTime) : new Date(),
    onChangeValue: handleDropoffTimeChange,
    disablePopper: isMobile,
    disableLabelAnimation: true
  }))), __jsx(InformativeCard, {
    message: t("TIME_INFO"),
    severity: "info",
    className: "w-full tx-pxs-light text-primary_text shadow-md"
  })), __jsx("div", {
    className: editCarSelectionApplyButtonContainer
  }, __jsx(MuscleButton, {
    dataTestId: "mobile-cars-search-button",
    variant: "solidXL",
    onClick: handleSearch
  }, t("UPDATE_SEARCH"))));
};